/*
  The marketing site (decisionflow.in) and the product (app.decisionflow.in) are
  served from the same build, so "where does Log in point?" cannot be a plain
  build-time constant — it has to resolve at runtime.

  On the marketing host, auth links are absolute and cross over to the app host.
  Anywhere else (the app host itself, localhost, a preview build) they stay
  relative, so the site is still clickable in development without any env setup.
*/

// Hosts that serve the product. Everything else showing this bundle is treated
// as a marketing host. Override with a comma-separated REACT_APP_APP_HOSTS.
const APP_HOSTS = (process.env.REACT_APP_APP_HOSTS || "app.decisionflow.in")
  .split(",")
  .map((h) => h.trim().toLowerCase())
  .filter(Boolean);

export const APP_ORIGIN = (
  process.env.REACT_APP_APP_URL || "https://app.decisionflow.in"
).replace(/\/+$/, "");

const LOCAL_HOSTS = ["localhost", "127.0.0.1", "[::1]", "0.0.0.0"];

function hostname() {
  if (typeof window === "undefined") return "";
  return window.location.hostname.toLowerCase();
}

export function isAppHost() {
  return APP_HOSTS.includes(hostname());
}

// Development and LAN builds serve both halves off one origin, so auth links
// must stay relative there — otherwise "Log in" on localhost walks the
// developer straight into production.
function isLocal() {
  const h = hostname();
  return (
    LOCAL_HOSTS.includes(h) ||
    /^192\.168\.|^10\.|^172\.(1[6-9]|2\d|3[01])\./.test(h)
  );
}

export function appUrl(path) {
  return isAppHost() || isLocal() ? path : `${APP_ORIGIN}${path}`;
}

export const LOGIN_URL = () => appUrl("/login");
export const SIGNUP_URL = () => appUrl("/register-company");

// The marketing host, for links back to it from the app (e.g. the login
// page footer). Mirrors appUrl's logic in reverse: on the app host or a
// local/LAN build the marketing site and the app share one origin, so "/"
// already resolves to it there.
const MARKETING_ORIGIN = (
  process.env.REACT_APP_MARKETING_URL || "https://decisionflow.in"
).replace(/\/+$/, "");

export function marketingUrl(path = "/") {
  return isAppHost() && !isLocal() ? `${MARKETING_ORIGIN}${path}` : path;
}

/*
  Printable brochures, served straight out of /public. Keyed by the product id
  in siteContent so a section can find its own without a lookup table.

  Page count and file size are deliberately not shown: they would need editing
  by hand every time a brochure is regenerated, and would be wrong the first
  time someone forgot.
*/
export const BROCHURES = {
  dms: {
    href: "/brochures/DecisionFlow-Project-Management.pdf",
    name: "Project & Document Management",
  },
  manufacturing: {
    href: "/brochures/DecisionFlow-Manufacturing.pdf",
    name: "Manufacturing & Production Tracking",
  },
};

export const CONTACT = {
  email: "sales@hexasphere.in",
  supportEmail: "support@hexasphere.in",
  phone: "+91 96650 63784",
  phoneHref: "+919665063784",
  app: "app.decisionflow.in",
};

export const LINKEDIN_URL =
  "https://www.linkedin.com/showcase/hexasphere-decisionflow/";

// Rates are quoted by sales, not published — the site and the brochures carry
// the trial length only. Nothing here should grow back into a price table
// without that decision being made again.
export const TRIAL_DAYS = 30;

// Traction figure agreed with sales: projects delivered end to end, unattributed.
export const PROJECTS_DELIVERED = "300+";
